import { render, staticRenderFns } from "./BotClient.vue?vue&type=template&id=4975d09a&"
import script from "./BotClient.vue?vue&type=script&lang=js&"
export * from "./BotClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports